var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('progress', {
    staticClass: "Polaris-ProgressBar__Progress",
    attrs: {
      "value": _vm.realProgress,
      "max": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Polaris-ProgressBar__Indicator",
    style: ({
      width: _vm.realProgress + '%'
    }),
    attrs: {
      "role": "progressbar",
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "Polaris-ProgressBar__Label"
  }, [_vm._v("\n            " + _vm._s(_vm.realProgress) + "\n        ")])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f4d2f97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f4d2f97","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisProgressBar.vue
// module id = 184
// module chunks = 0